import React, { useEffect, useState } from 'react';
import CompanyLogo from '../../../../components/ui/CompanyLogo';

interface ApplicationSuccessPageProps {
  companyName?: string;
  companyLogo?: string;
  location?: string;
  onWatchVideo?: () => void;
  phoneNumber?: string;
}

export const ApplicationSuccessPage = ({
  companyName = 'Starbucks',
  companyLogo = 'https://upload.wikimedia.org/wikipedia/en/thumb/d/d3/Starbucks_Corporation_Logo_2011.svg/1200px-Starbucks_Corporation_Logo_2011.svg.png',
  location = 'Downtown Seattle, WA',
  onWatchVideo = () => {},
  phoneNumber = '123-456-7890',
}: ApplicationSuccessPageProps) => {
  // Common header component reusing the same styles as JobLandingPage
  const renderHeader = () => (
    <div className="flex-shrink-0 bg-white px-5 pt-[14px]">
      <div className="flex items-start justify-between mb-2">
        <div className="flex items-start gap-2">
          <CompanyLogo
            src={companyLogo} 
            alt={`${companyName} logo`} 
            className="w-[57px] h-[57px] rounded"
          />
          <div className="flex flex-col justify-center">
            <h1 className="text-[19px] font-bold text-[#28292d]">
              {companyName}
            </h1>
            <p className="text-[17px] font-normal text-[#28292d]">
              {location}
            </p>
          </div>
        </div>
        <button 
          onClick={onWatchVideo}
          className="flex items-center gap-1 self-center"
        >
          <svg 
            className="w-[10px] h-[10px]" 
            viewBox="0 0 12 12" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M2 1.5L10 6L2 10.5V1.5Z" fill="#0156FF" stroke="#0156FF" strokeLinejoin="round" />
          </svg>
          <span className="text-[16px] font-normal text-[#0156FF]">Watch Video</span>
        </button>
      </div>
      <div className="h-px bg-[#b9babf] mx-4" />
    </div>
  );

  return (
    <div className="h-full flex flex-col bg-white overflow-y-auto">
      {renderHeader()}

      <div className="flex-1 flex flex-col items-center pt-[150px] px-5">
        <h2 className="text-[32px] font-bold text-black text-center leading-[1.4] mb-8">
          Application<br />Received!
        </h2>

        <div className="text-center mb-[50px]">
          <p className="text-[16px] text-black mb-1">
            We have sent a confirmation text to
          </p>
          <p className="text-[16px] font-bold text-black">
            {phoneNumber}
          </p>
        </div>

        <div className="text-center mb-[120px]">
          <p className="text-[16px] text-black">
            Expect to hear from us within <span className="font-bold">24 hours.</span>
          </p>
          <p className="text-[16px] text-black">
            We're excited to review your application!
          </p>
        </div>

        <div className="w-full flex flex-col items-center gap-4">
          <h3 className="text-[19px] font-bold text-black mb-2">
            What's Next?
          </h3>

          <div className="flex items-center gap-2 text-[15px] text-black">
            <CheckIcon />
            <span>Our team will review your application!</span>
          </div>

          <div className="flex items-center gap-2 text-[15px] text-black">
            <CheckIcon />
            <span>You'll receive a text with next steps.</span>
          </div>

          <div className="flex items-center gap-2 text-[15px] text-black">
            <CheckIcon />
            <span>Check your email for additional information.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const CheckIcon = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.5" cy="7.5" r="7.5" fill="black"/>
    <path d="M4 7.5L6.5 10L11 5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

